<template lang="pug">
   div
     app-text-field(v-model="form.orgName" label="Наименование организации получателя" :rules="[rules.required]")
     app-text-field(v-model="form.bank" label="Банк получателя"  :rules="[rules.required]")
     app-text-field(v-model="form.bill" label="Счет получателя" :rules="[rules.required, rules.number]")
     app-text-field(v-model="form.inn" label="ИНН получателя" :rules="[rules.required, rules.number]")
     app-text-field(v-model="form.kpp" label="КПП получателя" :rules="[rules.required, rules.number]")
     app-text-field(v-model="form.address" label="Адрес организации получателя"  :rules="[rules.required]")
     app-text-field(v-model="form.bankBik" label="БИК банка получателя" :rules="[rules.required, rules.number]")
     app-text-field(v-model="form.bankKpp" label="КПП банка получателя" :rules="[rules.required, rules.number]")
     app-text-field(v-model="form.bankInn" label="ИНН банка получателя" :rules="[rules.required, rules.number]")
     app-text-field(v-model="form.bankBill" label="Счет банка получателя" :rules="[rules.required, rules.number]")
     app-text-field(v-model="form.bankAddress" label="Адрес банка получателя"  :rules="[rules.required]")

</template>

<script>
import { $_validate_rules } from '@/common/ValidateRules'

export default {
  mixins: [$_validate_rules],
  props: {
    form: null,
  },
}
</script>
